var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTailLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 353 353",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 336 253 C 333 286 314 305 281 312 261 316 241 317 221 313 192 307 173 288 170 257 168 231 168 204 168 177 168 164 169 150 172 137 179 109 191 84 213 65 243 36 312 40 329 97 337 121 338 147 339 171 339 179 339 186 339 193 L 340 193 C 338 213 338 233 336 253 Z M 228 92 C 210 111 200 136 198 161 196 189 198 217 198 245 198 253 200 262 205 270 208 267 211 265 213 262 225 249 231 233 235 216 244 177 245 137 243 97 243 92 242 87 241 80 236 85 231 88 228 92 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 108 127 C 82 123 57 119 30 114 22 113 19 107 20 102 21 96 26 93 33 94 73 101 113 107 152 114 153 115 154 115 155 115 160 117 163 121 162 126 162 131 157 134 150 134 137 132 123 130 108 127 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 20 250 C 19 245 23 240 29 239 41 237 54 235 66 233 93 229 121 223 149 219 156 217 161 220 162 227 163 233 160 237 152 239 113 245 73 252 33 258 32 259 31 259 31 259 24 259 21 255 20 250 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 86 165 C 105 165 123 165 142 165 143 165 145 165 146 165 152 166 156 169 156 176 156 181 152 185 146 186 138 186 130 186 123 186 91 186 58 186 25 186 17 186 13 183 14 176 14 169 18 166 25 166 43 166 62 166 80 166 82 166 84 166 86 166 L 86 165 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailLight);
export default __webpack_public_path__ + "static/media/tail-light.b36e09064b128c133168ee3fe911b2c0.svg";
export { ForwardRef as ReactComponent };